import { Pipe, PipeTransform } from '@angular/core';
import { GroupLevel, GroupMemberStatus } from "../../shared/constants/group-constant";
@Pipe({
  name: 'groupMemberLevel'
})
export class GroupMemberLevelPipe implements PipeTransform {

  transform(value): string {
      switch (value) {
          case GroupLevel.admin:
              return 'Creator';
          case GroupLevel.moderator:
              return 'Admin'
          default:
              return value;
      }
  }
}
